import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import Decimal from 'decimal.js';
import { NumberValueProps } from './NumberValue';
import { handleIncomeColor } from '../styles/functions';
import { mapFontSizeTypeToLineHeight, StylesIndexInjections } from 'common-react';

export default makeUiStyles((theme: Theme) => createStyles({
  value: {
    display: 'flex',
    alignItems: 'baseline',
    gap: 4,
    color: ({ value = new Decimal(0), income }: NumberValueProps) => handleIncomeColor((value as Decimal).toNumber(), theme, income),
    fontSize: ({ valueSize }: NumberValueProps) => theme.fontSize[valueSize || 'base'],
    lineHeight: ({ valueSize }: NumberValueProps) => `${mapFontSizeTypeToLineHeight(valueSize)}px`,
  },
  code: {
    color: ({ value = new Decimal(0), income }: NumberValueProps) => handleIncomeColor((value as Decimal).toNumber(), theme, income),
    fontSize: ({ codeSize }: NumberValueProps) => theme.fontSize[codeSize || 'base'],
    lineHeight: ({ codeSize }: NumberValueProps) => `${mapFontSizeTypeToLineHeight(codeSize)}px`,
  },
  skeleton: {
    maxWidth: 'initial'
  },
}), { name: 'NumberValue', index: StylesIndexInjections.UI_MOLECULES });

